import { CapoPlugin } from "/builds/s-o-f/vkusilosos-frontend/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];